
import MHeader from '../Header/Header.vue';
import NotDate from '../NoData/NoData.vue';
import {
getRobsList
} from '../../api';
import XImg from 'vux/src/components/x-img/index.vue'

export default {
components: {
MHeader,
XImg,
getRobsList,
NotDate
},
data() {
return {
res: []
}
},
methods: {
getDate() {
this.$store.commit('showIsLoading');
getRobsList().then(res => {
if (res.data.error_code) {
console.error(res);
alert(res.data.msg);
return;
};
this.res = res.data.data ? res.data.data : [];
console.log(this.res);
});
},

progress(res) {
var toal = res.buy_number;
var now = res.sold_number;
return parseInt((now / toal).toFixed(2) * 100) + '%';
},
back() {
this.$router.push({
path: '/home'
});
}
},
mounted() {
if (!this.res.length) {
this.getDate();
}
},
beforeRouteEnter: (to, from, next) => {
next(vm => {
vm.getDate();
})
}
};



// WEBPACK FOOTER //
// ./src/components/HomeTakeWine/HomeTakeWine.vue